import { render, staticRenderFns } from "./BackupDialog.vue?vue&type=template&id=34c8f924&"
import script from "./BackupDialog.vue?vue&type=script&lang=js&"
export * from "./BackupDialog.vue?vue&type=script&lang=js&"
import style0 from "./BackupDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports